import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { initialState, OfficeState, defaultPagination } from './office.state';
import * as officeActions from './office.actions';
import { Pagination } from '@interfaces';

const reducer: ActionReducer<OfficeState, Action> = createReducer(
  initialState,

  on(
    officeActions.createOffice,
    (state): OfficeState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    officeActions.createOfficeSuccess,
    (state, { office }): OfficeState => ({
      ...state,
      loading: false,
      loadedOffice: office,
      errorMessage: null,
    })
  ),
  on(
    officeActions.createOfficeError,
    (state, { errorMessage }): OfficeState => ({
      ...state,
      errorMessage,
      loading: false,
    })
  ),

  on(
    officeActions.getOffice,
    (state): OfficeState => ({
      ...state,
      loading: true,
      loadedOffice: null,
      errorMessage: null,
    })
  ),
  on(
    officeActions.getOfficeSuccess,
    (state, { office }): OfficeState => ({
      ...state,
      loading: false,
      loadedOffice: office,
      errorMessage: null,
    })
  ),
  on(
    officeActions.getOfficeError,
    (state, { errorMessage }): OfficeState => ({
      ...state,
      errorMessage,
      loading: false,
      loadedOffice: null,
    })
  ),

  on(
    officeActions.searchOffices,
    (state): OfficeState => ({
      ...state,
      loading: true,
      offices: [],
      errorMessage: null,
    })
  ),
  on(
    officeActions.searchOfficesSuccess,
    (state, { offices }): OfficeState => ({
      ...state,
      offices: offices.data,
      pagination: offices.pagination,
      loading: false,
      errorMessage: null,
    })
  ),
  on(
    officeActions.searchOfficesError,
    (state, { errorMessage }): OfficeState => ({
      ...state,
      errorMessage,
      loading: false,
      offices: [],
      pagination: { ...(defaultPagination as Pagination) },
    })
  ),

  on(
    officeActions.getOfficesSimpleList,
    (state): OfficeState => ({
      ...state,
      loading: true,
      offices: [],
      errorMessage: null,
    })
  ),
  on(
    officeActions.getOfficesSimpleListSuccess,
    (state, { offices }): OfficeState => ({
      ...state,
      offices: offices,
      loading: false,
      errorMessage: null,
    })
  ),
  on(
    officeActions.getOfficesSimpleListError,
    (state, { errorMessage }): OfficeState => ({
      ...state,
      errorMessage,
      loading: false,
      offices: [],
    })
  ),

  on(
    officeActions.updateOffice,
    officeActions.toggleAssignedVoivodeship,
    (state): OfficeState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    officeActions.updateOfficeSuccess,
    officeActions.toggleAssignedVoivodeshipSuccess,
    (state, { office }): OfficeState => ({
      ...state,
      loading: false,
      errorMessage: null,
      loadedOffice: office,
      offices: state.offices.map(officeInState => (officeInState.id === office.id ? office : officeInState)),
    })
  ),
  on(
    officeActions.updateOfficeError,
    officeActions.toggleAssignedVoivodeshipError,
    (state, { errorMessage }): OfficeState => ({
      ...state,
      errorMessage,
      loading: false,
    })
  ),

  on(
    officeActions.removeOffice,
    officeActions.restoreOffice,
    (state): OfficeState => ({
      ...state,
      loading: true,
      errorMessage: null,
    })
  ),
  on(
    officeActions.removeOfficeSuccess,
    officeActions.restoreOfficeSuccess,
    (state, { office }): OfficeState => ({
      ...state,
      loading: false,
      errorMessage: null,
      offices: state.offices.map(officeInState => (officeInState.id === office.id ? office : officeInState)),
    })
  ),
  on(
    officeActions.removeOfficeError,
    officeActions.restoreOfficeError,
    (state, { errorMessage }): OfficeState => ({
      ...state,
      errorMessage,
      loading: false,
    })
  ),

  // Office Visits Settings

  on(
    officeActions.getOfficeVisitsSettings,
    (state): OfficeState => ({
      ...state,
      loadingOfficeVisitsSettings: true,
      loadedOfficeVisitsSettings: null,
      errorMessage: null,
    })
  ),
  on(
    officeActions.getOfficeVisitsSettingsSuccess,
    (state, { officeVisitsSettings }): OfficeState => ({
      ...state,
      loadingOfficeVisitsSettings: false,
      loadedOfficeVisitsSettings: officeVisitsSettings,
      errorMessage: null,
    })
  ),
  on(
    officeActions.getOfficeVisitsSettingsError,
    (state, { errorMessage }): OfficeState => ({
      ...state,
      loadingOfficeVisitsSettings: false,
      loadedOfficeVisitsSettings: null,
      errorMessage,
    })
  ),

  on(
    officeActions.updateOfficeVisitsSettings,
    (state): OfficeState => ({
      ...state,
      loadingOfficeVisitsSettings: true,
      errorMessage: null,
    })
  ),
  on(
    officeActions.updateOfficeVisitsSettingsSuccess,
    (state, { office }): OfficeState => ({
      ...state,
      loadingOfficeVisitsSettings: false,
      loadedOffice: office,
      loadedOfficeVisitsSettings: office.visitsSettings,
      errorMessage: null,
    })
  ),
  on(
    officeActions.updateOfficeVisitsSettingsError,
    (state, { errorMessage }): OfficeState => ({
      ...state,
      loadingOfficeVisitsSettings: false,
      loadedOfficeVisitsSettings: null,
      errorMessage,
    })
  )
);

export function officeReducer(state: OfficeState | undefined, action: Action): OfficeState {
  return reducer(state, action);
}
